var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b89175f1cb4a54b9a900d9a8e074d37.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3349f09ac0df100b9e4aeee45a8ce92a.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d318aea32bb0e224038f6386f6e2f0b3.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    